import {
    apiRequest,
    saudaraDetail
} from "../../../../../../services/adapters/kepegawaian/saudaraService"

class DetailRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", saudaraDetail, {
            params: query
        }, true)
    }
}

export default DetailRepository